<template lang="pug">
div
  el-row
    app-aviso-vtn(
      @att='att'
      :processo="processo",
      @reload="loadDados"
    )
    app-aviso-desarquivamento(
      v-if="processo != null"
      :processo="processo",
      @reload="loadDados"
    )
  section(class="separable")
    div(class="container")
      el-row
        el-col(:span="24")
          div.cardListagem(class="card")
            div(class="card-header").titulo {{ isEstadoMA ? 'Listagem de Boletos' : 'Listagem de DAEs'}}
            div(class="card-body")
              el-row(slot="tabela").contentCard
                el-table.table-div(
                  :data="daesBoleto",
                  empty-text="Não há registros."
                )
                  el-table-column(
                    label='Tipo'
                    prop=""
                    :formatter="formatterTipo"
                  )
                  el-table-column(
                    width="130"
                    label="Vencimento"
                    prop="dataVencimento"
                  )
                  el-table-column(
                    label="Situação"
                    prop="status"
                    width="200"
                  )
                  el-table-column(
                    width="140"
                    label="Valor"
                    prop="valor"
                    :formatter="formatterNumber"
                  )
                  el-table-column(
                    width="80"
                    :label="isEstadoMA ? 'Boletos' : 'DAEs'"
                    align="center"
                  )
                    template(slot-scope="scope")
                        div(
                          v-if="scope.row.status != 'ADIANTADA'"
                          @click="downloadBoleto(scope.row)"
                        )
                          i.download(class="fa fa-download")
              app-paginacao(
                :total="total",
                :pagina="pagina",
                @changePage="changePage"
              )

</template>

<script>
import utils from '@/utils/utils'
import { mapActions } from 'vuex'
import AppDividerRefreshButton from '../../../../components/AppDividerRefreshButton'
import AppPaginacao from '@/components/AppPaginacao'
import AppAvisoVtn from './AppAvisoVtn'
import AppAvisoDesarquivamento from './AppAvisoDesarquivamento'

export default {
  components: {
    AppDividerRefreshButton,
    AppPaginacao,
    AppAvisoVtn,
    AppAvisoDesarquivamento
  },

  data () {
    return {
      daesBoleto: [],
      loading: false,
      total: 0,
      pagina: 1,
      processo: null,
      key: 0,
      dadosVtn: {}
    }
  },

  async created () {
    await this.getProcessoByProtocolo(this.$route.params.idCadastro).then((r) => {
      this.processo = r
    })
    if (this.isEstadoAP) {
      this.dadosVtn = await this.getVtnByIdProcesso(this.processo.id)
    }
    await this.loadDados()
  },

  computed: {
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    },
    isEstadoPA () {
      return process.env.ESTADO === 'pa'
    }
  },

  methods: {
    att () {
      this.loadDados()
    },
    async changePage (newPage) {
      this.pagina = newPage
      await this.loadDados()
    },

    ...mapActions({
      baixarBoleto: 'dae/downloadDaeByBoleto',
      findDaes: 'dae/findDaesByNumeroProcesso',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso'
    }),

    async downloadBoleto (boleto) {
      this.baixarBoleto(boleto.id)
    },

    async loadDados () {
      if (this.isEstadoAP) {
        this.daesBoleto = this.dadosVtn.parcelasAp.filter((parcela) => parcela.status === 'EMITIDA' || parcela.status === 'ADIANTADA')
        this.dadosVtn.parcelasAp.forEach((parcela) => {
          parcela.dataVencimento = parcela.dataVencimentoFormatada
          parcela.receita = `VTN Parcela ${parcela.numero}`
        })
      }
      this.findDaes({
        origemDocumento: this.processo.numeroProcesso,
        pagina: this.pagina - 1,
        ordem: 'dataCriacao',
        ordemDirecao: 'DESC'
      }).then(response => {
        this.daesBoleto = response.content.filter(d => !d.isReemitida)
        this.total = response.totalElements
      })
      this.loading = false
    },

    formatterTipo (value) {
      if (value.receita === 'RECEITA DE VALOR DA TERRA NUA-VTN/ITERPA 5803-3') {
        if (value.parcelaExcedente) {
          return `${value.receita} (referente ao excedente da área)`
        }
        if (value.numeroReferencia > 10) {
          return `${value.receita} (referente a quitação das parcelas restantes)`
        }
        return `${value.receita} (referente a ${value.numeroReferencia}° parcela)`
      }
      return value.receita
    },

    formatterNumber (value) {
      const options = {
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2
      }
      return utils.format(this.isEstadoAP ? value.valor : value.valorRealDoBoleto, options)
    }
  }
}
</script>

<style lang="scss" scoped>
  .alinhamento {
    text-align: left;
  }

  .download {
    cursor: pointer;
  }

  .titulo {
    color: #424242;
    font-size: 1.5rem;
  }

  @media (max-width: 780px) {
    .cardListagem {
      position: relative;
      width: 300px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppGerenciamentoDaes.vue